// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._SbEuvDuf13ykZDfkwQd {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0.5rem;
    column-gap: .5rem;
}

.tUZALkPwyIONujkeuoHy {
    display: grid;
    gap: 20px;
    grid-auto-rows: max-content;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    margin-bottom: 16px;
    margin-top: 8px;
    overflow-x: hidden;
    overflow-y: scroll;
    width: 100%;
}

.u2TlQvcO87EksDnuayVB{
    display: grid;
    align-self: center;
    height: 100%;
    align-items: center;
    justify-content: center;
}

.Yh8YUwDTjvwd0lFYAWMl {
    display: grid;
    width: 100%;
    height: 100%;
}

.Yh8YUwDTjvwd0lFYAWMl svg {
    font-size: 50px !important;
}

.Yh8YUwDTjvwd0lFYAWMl > div {
    justify-content: center;
}

.Yh8YUwDTjvwd0lFYAWMl path {
    fill: #aaaaaa !important;
}

.Yh8YUwDTjvwd0lFYAWMl p {
    fill: #aaaaaa !important;
}

.bnbE21RbZfYayQzlUR_o {
    margin-bottom: 1rem;
}

.SwerTc4MZ14HMvbw_C8C {
    height: 2rem;
}

.bnbE21RbZfYayQzlUR_o.WpkjeiaHeqrX8uABsheq {
    font-weight: 400;
    color: #666687;
}

.Xv26BKHJSJJWbqqX2zKN.wmjIKvkJJUo_Bps7DfmM {
    font-weight: 400;
}

.Rr5nz8eLbAxnR06AROLN {
    display: flex;
    column-gap: .5rem;
}

.Xv26BKHJSJJWbqqX2zKN._2QV4oZwcq_U5xX8O7eNR {
    font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/widen-library/admin/src/components/WidenSearchBox.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,4DAA4D;IAC5D,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".search-controls {\n    align-items: center;\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: 0.5rem;\n    column-gap: .5rem;\n}\n\n.results-container {\n    display: grid;\n    gap: 20px;\n    grid-auto-rows: max-content;\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n    margin-bottom: 16px;\n    margin-top: 8px;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    width: 100%;\n}\n\n.loader{\n    display: grid;\n    align-self: center;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n}\n\n.empty-state {\n    display: grid;\n    width: 100%;\n    height: 100%;\n}\n\n.empty-state svg {\n    font-size: 50px !important;\n}\n\n.empty-state > div {\n    justify-content: center;\n}\n\n.empty-state path {\n    fill: #aaaaaa !important;\n}\n\n.empty-state p {\n    fill: #aaaaaa !important;\n}\n\n.header {\n    margin-bottom: 1rem;\n}\n\n.input-search {\n    height: 2rem;\n}\n\n.header.subtitle {\n    font-weight: 400;\n    color: #666687;\n}\n\n.header-title.prefix {\n    font-weight: 400;\n}\n\n.header-title-wrapper {\n    display: flex;\n    column-gap: .5rem;\n}\n\n.header-title.suffix {\n    font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search-controls": `_SbEuvDuf13ykZDfkwQd`,
	"results-container": `tUZALkPwyIONujkeuoHy`,
	"loader": `u2TlQvcO87EksDnuayVB`,
	"empty-state": `Yh8YUwDTjvwd0lFYAWMl`,
	"header": `bnbE21RbZfYayQzlUR_o`,
	"input-search": `SwerTc4MZ14HMvbw_C8C`,
	"subtitle": `WpkjeiaHeqrX8uABsheq`,
	"header-title": `Xv26BKHJSJJWbqqX2zKN`,
	"prefix": `wmjIKvkJJUo_Bps7DfmM`,
	"header-title-wrapper": `Rr5nz8eLbAxnR06AROLN`,
	"suffix": `_2QV4oZwcq_U5xX8O7eNR`
};
export default ___CSS_LOADER_EXPORT___;
